import React from 'react'
import styled from 'styled-components'
import { customTheme } from '../../../../styles/theme'
import { applyProps, PropTypesStyledHTML } from '../../../../utils/styled_helpers'

type SizeType = 'sm' | 'md' | 'lg' | 'xl' | 'xxl'
const sizes: SizeType[] = ['sm', 'md', 'lg', 'xl', 'xxl']
const defaultSize: SizeType = 'xl'

const getPosSize = (size?: SizeType) => {
  return size && sizes.indexOf(size) >= 0 ? sizes.indexOf(size) : sizes.indexOf(defaultSize)
}

const handleMediaContainer = (value: SizeType): string => {
  switch (value) {
    case 'sm': return customTheme.breakpoints[0]
    case 'md': return customTheme.breakpoints[1]
    case 'lg': return customTheme.breakpoints[2]
    case 'xl': return customTheme.breakpoints[3]
    case 'xxl': return customTheme.breakpoints[4]
    default: return '0'
  }
}

const handleMaxWContainer = (value: SizeType): string => {
  switch (value) {
    case 'sm': return '576px'
    case 'md': return '768px'
    case 'lg': return '992px'
    case 'xl': return '1200px'
    case 'xxl': return '1400px'
    default: return '0'
  }
}

interface ContainerProps extends PropTypesStyledHTML {
  fluid?: boolean;
  size?: SizeType;
  d?: string;
  px?: string | number;
}

export const ContainerStyled = styled.div<ContainerProps>`
  ${(props) => applyProps(props)}
  ${({ fluid, size, d, px }) => {
    let html = ''
    if (!fluid) {
      for (let i = 0; i <= getPosSize(size); i++) {
         html += `
          @media (min-width: ${handleMediaContainer(sizes[i])}) {
            max-width: ${handleMaxWContainer(sizes[i])};
          }      
        `
      }
    }
    if (d === 'grid') {
      html += `
        @media (max-width: 992px) {
          grid-template-columns: repeat(1, 1fr);
          max-width: 100% !important;
          padding-left: calc(${px} * 0.1);
          padding-right: calc(${px} * 0.1);
        }
      `
    }

    html += `
    /* width */
      div::-webkit-scrollbar {
          height: 2px;
          width: 10px;
      }

      /* Track */
      div::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px grey;
          border-radius: 10px;
      }

      /* Handle */
      div::-webkit-scrollbar-thumb {
          background: #3A3A3A;
          border-radius: 10px;
      }

      /* Handle on hover */
      div::-webkit-scrollbar-thumb:hover {
          background: #3A3A3A;
      }

      div::-webkit-scrollbar-button {
          width: 5px;
      }
    `
    return html
  }}
`

export const Container: React.FC<ContainerProps> = (props) => (
  <ContainerStyled {...props}>
    {props.children}
  </ContainerStyled>
)
